import { ThemeConfig } from '@chakra-ui/theme';

/**
 * Extend the base shared theme with the custom colors and variants in portal.
 *
 * @see https://chakra-ui.com/docs/theming/customize-theme
 */
export const config: ThemeConfig = {
    useSystemColorMode: false,
    initialColorMode: 'light',
    cssVarPrefix: '3p'
};
